import { BookDemoBanner as BookDemoBannerComponent } from '@reconvert/react-ui-component';
import { useTranslation } from 'react-i18next';
import { Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { selectShopInfoState } from '../../ReviewProviderWrapper';
import { updateShopInfoThunk, updateShopInfoLocal } from '../../app/slice/shopinfoSlice';
import { selectAppState, setBookDemoBannerVisible } from '../../app/slice/appSlice';
import { BOOK_DEMO_BANNER_CALENDLY_URL, BOOK_DEMO_BANNER_MAX_CAP } from '../../config';

type BookDemoBannerProps = {
    location: string;
    marginBottom?: string;
    buttonText?: string;
    isVertical?: boolean;
}

const BookDemoBanner = ({ location, marginBottom, buttonText, isVertical }: BookDemoBannerProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const { shopInfo } = useAppSelector(selectShopInfoState);
    const { subscriptionDetails, isBookDemoBannerVisible } = useAppSelector(selectAppState);

    // Reset banner visibility to true when this component loads so it shows again (e.g. when help modal reopens)
    useEffect(() => {
        dispatch(setBookDemoBannerVisible(true));
    }, [dispatch]);

    const handleClose = async (checked: boolean) => {
        try {
            dispatch(setBookDemoBannerVisible(false));
            if (checked) {
                const key = `hide_book_demo_banner_${location}`;

                // Update locally in Redux store
                dispatch(updateShopInfoLocal({
                    [key]: 1,
                }));
                // Update in backend
                await dispatch(updateShopInfoThunk({
                    [key]: "1",
                }));
            }

        } catch (error) {
            console.error(error);
        }
    }

    return (
        isBookDemoBannerVisible && (subscriptionDetails?.maxCap || 0) > Number(BOOK_DEMO_BANNER_MAX_CAP) && shopInfo?.[`hide_book_demo_banner_${location}`] !== 1 ? (
            <Flex mb={marginBottom || '20px'} mx={isVertical ? '4px' : '0px'}>
                <BookDemoBannerComponent
                    title={t('You are eligible for a personal demo call with our team!')}
                    description={isVertical ? undefined : t("We noticed you're a large store, which makes you eligible for a free demo call! Stores like yours see 2.3x more revenue with Upsell.com. Click below to start your journey to growth!")}
                    buttonText={buttonText || t('Book a demo')}
                    buttonUrl={BOOK_DEMO_BANNER_CALENDLY_URL}
                    onClose={handleClose}
                    isVertical={isVertical}
                    showCheckbox={true}
                    checkboxText={t("Don't show it again")}
                />
            </Flex>
        ) : null
    )
}

export default BookDemoBanner;